module.exports = __webpack_public_path__ + "img/ic_nav_activity.1b1ad372.svg";